/* My Acre — variant to gallery bridge. 9 Sep 2026 (Claude, Hayden approved).
 *
 * THE FAULT: picking a colour changed the price, the SKU and the chosen-value label, but the
 * main gallery never moved. The theme does ship a gallery.selectMediaByVariant() (superstore.js),
 * but our custom picker (.ma-options radios, see snippets/product-options.liquid) writes straight
 * to the hidden select and the theme's own variant-change listener never hears it, so the call
 * is never made. On Aluvy that meant clicking Reseda while looking at a Blanc brazier.
 *
 * THE FIX: listen on the picker ourselves, resolve the selected variant to its media id, and
 * CLICK the matching thumbnail. Going through the theme's own thumbnail handler rather than
 * poking the slider directly keeps the slide transition, the zoom target and the thumbnail
 * selected-state all behaving exactly as they already do.
 *
 * Requires each variant to have media attached (productVariantAppendMedia). Where a variant has
 * no media of its own the script does nothing, which leaves the gallery where the customer left
 * it. That is the correct behaviour, not a failure.
 */
(function () {
  'use strict';
  if (window.__maVariantGallery) return;
  window.__maVariantGallery = true;

  var variantToMedia = null;
  var productVariants = [];
  var variantFeatured = {}; // variant id -> its own featured media id (product.js variants[].featured_media), studio pages only
  var studio = null; // { note, images: { "<option values joined by ||>": url } } from data-ma-cards-studio (tiles mode only)

  function handle() {
    var canonical = document.querySelector('link[rel="canonical"]');
    var path = canonical ? new URL(canonical.href).pathname : window.location.pathname;
    var m = path.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function load() {
    var h = handle();
    if (!h) return Promise.resolve(null);
    return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.media) return null;
        productVariants = p.variants || [];
        variantFeatured = {};
        productVariants.forEach(function (v) { if (v.featured_media && v.featured_media.id) variantFeatured[v.id] = v.featured_media.id; });
        var map = {};
        p.media.forEach(function (item) {
          (item.variant_ids || []).forEach(function (vid) {
            if (map[vid] == null) map[vid] = item.id;   // first media wins, matching Shopify
          });
        });
        return map;
      })
      .catch(function () { return null; });
  }

  function selectedVariantId() {
    var sel = document.querySelector('[data-product-options-container] select[name="id"], form[data-product-form] select[name="id"], form[data-product-form] input[name="id"]');
    return sel && sel.value ? String(sel.value) : null;
  }

  function show(mediaId) {
    var thumb = document.querySelector('.product-gallery--media-thumbnail[data-media="' + mediaId + '"]');
    if (thumb && thumb.getAttribute('data-gallery-selected') !== 'true') { thumb.click(); return; }
    // Thumbnails are hidden when a product has a single image; move the viewer directly instead.
    var fig = document.querySelector('figure[data-gallery-figure][data-media="' + mediaId + '"]');
    if (fig && fig.getAttribute('data-gallery-selected') !== 'true' && typeof fig.scrollIntoView === 'function') {
      fig.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  /* 25 Oct 2026 (Claude, Hayden approved): when a variant has no image of its own and the page carries studio data
     (Trendz tiles mode), move the gallery to the nearest STUDIO render, same size and storage first, and say so in a
     caption, instead of staying on whatever was showing (which could be a different fireplace). Pages without
     data-ma-cards-studio never reach this code path. */
  var FB_STYLE = '[data-gallery-viewer] .ma-media-caption--fb{position:absolute;left:10px;bottom:12px;z-index:3;max-width:calc(100% - 175px);margin:0;padding:5px 10px;border-radius:8px;background:rgba(54,61,69,.85);color:#FFFFFF;font:500 12px/1.35 Inter,system-ui,-apple-system,"Segoe UI",sans-serif;letter-spacing:0;text-transform:none;white-space:normal;pointer-events:none;box-shadow:0 1px 2px rgba(0,0,0,.18)}@media (max-width:749px){[data-gallery-viewer] .ma-media-caption--fb{left:8px;max-width:calc(100% - 150px);font-size:11px;padding:4px 8px}}[data-gallery-viewer] .ma-fb-on .ma-media-caption:not(.ma-media-caption--fb){display:none}';
  function ensureFbStyle() {
    if (document.getElementById('ma-fb-style')) return;
    var s = document.createElement('style'); s.id = 'ma-fb-style'; s.textContent = FB_STYLE; document.head.appendChild(s);
  }
  function clearFallback() {
    Array.prototype.forEach.call(document.querySelectorAll('.ma-media-caption--fb'), function (c) {
      var f = c.parentNode; if (f && f.classList) f.classList.remove('ma-fb-on'); c.parentNode.removeChild(c);
    });
  }
  function loadStudio() {
    var el = document.querySelector('[data-ma-cards-studio]');
    if (!el) return;
    try { var s = JSON.parse(el.textContent || '{}'); if (s && s.images) studio = s; } catch (e) { studio = null; }
  }
  function fallback(vid) {
    if (!studio || !productVariants.length) return;
    var v = productVariants.filter(function (x) { return String(x.id) === vid; })[0];
    if (!v || !v.options) return;
    var bestKey = null, best = -1;
    Object.keys(studio.images).forEach(function (k) {
      var parts = k.split('||'), s = 0;
      parts.forEach(function (p, i) { if (v.options[i] === p) s++; });
      if (s > best) { best = s; bestKey = k; }
    });
    if (!bestKey) return;
    var sv = productVariants.filter(function (x) { return (x.options || []).join('||') === bestKey; })[0];
    var mediaId = sv && variantFeatured[sv.id];
    if (!mediaId) return;
    show(mediaId);
    var fig = document.querySelector('figure[data-gallery-figure][data-media="' + mediaId + '"]');
    if (!fig || !studio.note) return;
    ensureFbStyle(); clearFallback();
    var c = document.createElement('figcaption'); c.className = 'ma-media-caption ma-media-caption--fb'; c.textContent = studio.note;
    fig.classList.add('ma-fb-on'); fig.appendChild(c);
  }

  function sync() {
    if (!variantToMedia) return;
    var vid = selectedVariantId();
    if (!vid) return;
    var mediaId = variantToMedia[vid];
    if (mediaId) { clearFallback(); show(mediaId); return; }
    if (!studio) return;
    // The theme's own handler moves the gallery to a variant's featured image; only a variant with none needs the fallback.
    if (variantFeatured[vid]) { clearFallback(); return; }
    fallback(vid);
  }

  function bind() {
    var scope = document.querySelector('[data-product-options-container]') || document;
    // The picker updates the hidden select, so listen for both the radio click and the resulting
    // change. A rAF lets the theme finish writing the select before we read it.
    ['change', 'click'].forEach(function (ev) {
      scope.addEventListener(ev, function (e) {
        if (!e.target || !e.target.closest) return;
        // Option cards (tiles mode) are not inside .ma-option-value, so listen to them too, but only on pages that carry
        // studio data, so every other card picker (Polito stands, Shadowspec and others) behaves exactly as before.
        if (!e.target.closest('.ma-option-value, .ma-options, select[name="id"]') && !(studio && e.target.closest('[data-ma-cards]'))) return;
        requestAnimationFrame(function () { requestAnimationFrame(sync); });
      }, true);
    });
  }

  function init() {
    if (!document.querySelector('[data-product-gallery]')) return;
    load().then(function (map) {
      if (!map) return;
      variantToMedia = map;
      loadStudio();
      bind();
      if (studio) { var v0 = selectedVariantId(); if (v0 && !variantFeatured[v0]) fallback(v0); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
